<template>
  <v-card
    v-if="approvalHeader"
    style="border-radius: 10px"
    flat
    :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
  >
    <v-toolbar flat dense class="beez-bold">
      Task Header
      <v-spacer></v-spacer>
      <v-btn flat icon @click="headerPanel = !headerPanel">
        <v-icon>{{ headerPanel ? 'expand_less' : 'expand_more' }} </v-icon>
      </v-btn>
    </v-toolbar>
    <div v-if="headerPanel">
      <v-layout align-center justify-space-around row fill-height wrap>
        <template v-for="(item, key) in approvalHeader.dimensionList">
          <v-flex :key="key + 'flex-dim'">
            <div>
              <br />
              <div class="beez-bold">{{ item.caption }}</div>
              <div class="subheading">{{ item.value }}</div>
              <br />
            </div>
          </v-flex>
        </template>
        <template v-for="(item, key) in approvalHeader.metricList">
          <v-flex :key="key + 'flex-metric'">
            <div>
              <br />
              <div class="beez-bold">{{ item.caption }}</div>
              <div class="subheading">
                {{ numberFormat(item.value) }}
                <span style="font-size: 0.8em">{{ item.unit }}</span>
              </div>
              <br />
            </div>
          </v-flex>
        </template>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'UserApprovalHeader',
  props: {
    approvalHeader: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      headerPanel: false
    }
  },
  methods: {
    numberFormat(param) {
      return parseFloat(param).toLocaleString()
    }
  }
}
</script>

<style scoped></style>
